import { Box, Flex } from '@chakra-ui/react';
import { Tag, Text } from '@kula-ai/components';
import { File05, XClose } from '@kula-ai/icons-core';
import type { AttachmentChipsProps } from './Composer.types';

export const AttachmentChips = ({ files, onRemove }: AttachmentChipsProps) => {
  if (files.length === 0) return null;
  return (
    <Flex wrap="wrap" gap="6px">
      {files.map((file, idx) => (
        <Tag
          key={`${file.name}-${idx}`}
          variant="white"
          size="md"
          label={file.name}
          leftElement={<File05 size={16} />}
          rightElement={
            <Box
              as="button"
              type="button"
              aria-label={`Remove ${file.name}`}
              onClick={() => onRemove(idx)}
              display="inline-flex"
              cursor="pointer"
            >
              <XClose size={16} />
            </Box>
          }
        />
      ))}
    </Flex>
  );
};

// Oversized files can't be attached (10 MB cap) — say so instead of dropping
// them silently, which read as a successful attach.
export const RejectedFilesNote = ({ names }: { names: string[] }) => {
  if (names.length === 0) return null;
  return (
    <Text
      variant="small"
      className="text-error-600 mt-1"
      data-test-id="composer-file-rejected"
    >
      {names.join(', ')}{' '}
      {names.length === 1
        ? 'is over the 10 MB limit and wasn’t attached.'
        : 'are over the 10 MB limit and weren’t attached.'}
    </Text>
  );
};
